import BaseAxios from './endpoints';

const configs = {
  BaseAxios,
};

export default configs;
